module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Visa":"Show","Stäng":"Close","Info!":"Info!","Något gick fel! Försök igen lite senare.":"Something went wrong! Please try again later.","Klart!":"Done!","Ny avisering":"New notification"},"sv":{"Visa":"Visa","Stäng":"Stäng","Info!":"Info!","Något gick fel! Försök igen lite senare.":"Något gick fel! Försök igen lite senare.","Klart!":"Klart!","Ny avisering":"Ny avisering"}}')
  delete Component.options._Ctor
}
